<div class="width-100 height-100">
    <div class="twc-d-flex justify-space-between twc-m-2">
        <h3 class="twc-h3 twc-h3-bold" *ngIf="title"> {{ title | translate }} </h3>
    </div>
    <div class="cards-container twc-d-flex">
        <div class="card-container" *ngFor="let element of elements">
            <div class="margins-card">
                <cw-card [catalogObject]="element.catalogObject" [isDashboard]="true" [iconDetail]="element.iconDetail"
                    (objectClick)="onClickElement(element.catalogObject)">
                </cw-card>
            </div>
        </div>

        <div *ngIf="msgError" class="twc-message-box twc-message-box-error twc-mt-3 twc-mb-3">
            <p translate> {{ msgError | translate }} </p>
        </div>

        <!-- No opened projects -->
        <div *ngIf="!msgError && elements?.length===0">
            {{ 'DASHBOARD.NO_OPENED_PROJECTS' | translate }}
        </div>
    </div>
    <div *ngIf="isLoading" class="width-100 height-100 twc-d-flex justify-content-center twc-row-center">
        <twc-loader size="large"></twc-loader>
    </div>
</div>